import { IApplicationState } from '../../types/redux';

export const getBuilderChatButtonClicked = (state: IApplicationState): boolean => !!state.builderChat.isButtonClicked;
